import { lazy } from 'react';

export const path = '/:organization/application';
export const exact = true;

export const component = lazy(() => import('./ApplicationRoot'));
